import React from 'react'
import Head from 'next/head'
import Layout from '../../components/Layout'
import { privacyItems } from '../../helpers/privacy'

export default function Privacy() {
  return (
    <>
      <Head>
        <title key="title">Privacy | Tube Transcripts</title>
        <link
          rel="canonical"
          href="https://www.tubetranscripts.com/privacy"
          key="canonical"
        />
        <meta
          property="og:url"
          href="https://www.tubetranscripts.com/privacy"
          key="og-url"
        />
      </Head>
      <section className="container w-full mx-auto text-center lg:w-4/5">
        <h1 className="w-full mb-6 text-3xl font-bold text-gray-900 uppercase lg:text-4xl">
          Privacy
        </h1>
        {privacyItems.map((element) => (
          <div
            id={element.id}
            key={element.id}
            className="w-full px-8 py-6 mb-4 bg-white rounded shadow">
            {element.headline && (
              <h2
                className="mb-8 text-lg font-bold text-left text-purple-500 lg:text-xl"
                dangerouslySetInnerHTML={{ __html: element.headline }}
              />
            )}
            <p
              className="text-sm text-left text-gray-900"
              dangerouslySetInnerHTML={{ __html: element.text }}
            />
          </div>
        ))}
      </section>
    </>
  )
}

Privacy.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>
}
